import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { ButtonComponent } from '../core/buttons/button.component';
import { ActionRowComponent } from '../core/panels/action-row.component';
import { DialogComponent } from '../core/panels/dialog.component';
import { SelectComponent } from '../core/controls/select.component';
import { ListItem } from '../../models/api/core/list/list-item';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-provider-search-dialog',
  imports: [
    CommonModule,
    DialogComponent,
    ActionRowComponent,
    ButtonComponent,
    SelectComponent,
  ],
  template: ` <app-dialog
    #dialog
    [visible]="visible"
    [closable]="true"
    label="Confirmation"
    width="30rem"
    appendTo="body"
    (visibleChange)="onVisibleChange($event)"
  >
    <ng-template #content>
      <div class="tw-pb-4 tw-pt-3">
        <app-select
          [options]="contracts"
          optionLabel="description"
          [control]="contractControl"
          label="Client"
          [multiple]="false"
          [showClear]="false"
        />
      </div>
      <div class="tw-pt-2 tw-pb-8">
        You're opening a new tab or window to an external site.<br />Please
        disable popup blockers if needed.
      </div>
      <app-action-row>
        <app-button (click)="onConfirm()" right1 label="Continue" />
        <app-button
          (click)="visible = false"
          emphasis="Low"
          right2
          label="Back"
        />
      </app-action-row>
    </ng-template>
  </app-dialog>`,
  styles: ``,
})
export class ProviderSearchDialogComponent implements OnDestroy {
  @Input()
  contracts: ListItem[] = [];

  @Output()
  confirm = new EventEmitter<string | null>();

  contractControl = new FormControl<ListItem | null>(null);

  protected visible = false;

  ngOnDestroy(): void {
    this.visible = false;
  }

  show(): void {
    if (this.contracts.length > 0 && !this.contractControl.value) {
      this.contractControl.setValue(this.contracts[0]);
    }
    this.visible = true;
  }

  onConfirm() {
    this.visible = false;

    const selectedContract = this.contractControl.value?.value ?? null;
    this.confirm.emit(selectedContract);
  }

  onVisibleChange(visible: boolean) {
    this.visible = visible;
  }
}
